import { render } from "./SimplePieChart.vue?vue&type=template&id=61de4966"
import script from "./SimplePieChart.vue?vue&type=script&lang=js"
export * from "./SimplePieChart.vue?vue&type=script&lang=js"

import "./SimplePieChart.vue?vue&type=style&index=0&id=61de4966&lang=scss"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__